import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    footer,
    hovered,
    pressed
  } = _ref;
  var transparentBackground = designContext.get('colors/backgrounds/transparent').toString();
  return {
    rootStyle: {
      backgroundColor: transparentBackground,
      border: 'none',
      cursor: 'pointer',
      outline: 'none',
      alignItems: 'center',
      WebkitTapHighlightColor: transparentBackground
    },
    viewStyle: {
      flexDirection: 'row',
      height: 50,
      justifyContent: 'space-between',
      marginBottom: footer ? -13 : 0,
      alignItems: 'center',
      paddingLeft: 15,
      paddingRight: 15,
      position: 'relative',
      textAlign: 'left',
      transition: 'background-color .2s ease'
    },
    textStyle: _objectSpread({
      color: designContext.get('context-menu/navigation-item-text-color', {
        interactiveState: pressed ? 'pressed' : hovered ? 'hovered' : 'default'
      }).toString()
    }, designContext.get('context-menu/navigation-item-text-style').styles())
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map